import React, { startTransition } from 'react';
import './Typewriter2.scss';
import Typewriter from 'typewriter-effect';
import images from '../../constants/images';
import { motion } from 'framer-motion';


const Typewriter2 = () => {
  return (
    <div className='app__wrapper_info'>
      <motion.img
        initial={{ scale: 0 }}
        animate={{ x: 0,scale: 1 }}
        transition={{duration: 3}}
        src={images.deadpool} alt="deadpool" className='app__info-img'/>

      <p className='p__opensans app__info-text'>
        Aloha, I'm a
      </p>

      <h1 className='p__poppins app__info-header'>
          <Typewriter
          options={{
              strings: ['Frontend Dev',
                        'Physician WannaBe',
                        'Sport Enthusiast'],
              autoStart: true,
              loop: true,
              delay: 20,
          }}
          />
      </h1>
    </div>
  )
}

export default Typewriter2